
import { Prop } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({
    components: {
    }
})
export default class DictionaryEditModal extends Vue {

    @Prop({
        default: () => new OM.LocalizedEntity()
    }) localized: string;
    
    @Prop({
        type: [Function]
    }) callback: any;

    localModel: OM.LocalizedEntity = null;

    created() {
        this.localModel = JSON.parse(JSON.stringify(this.localized));
    }

    save() {
        this.callback(this.localModel);
    }

    close() {
        this.$emit('close');
    }

}
